import { Component, Input, Output,EventEmitter, ViewChild } from '@angular/core';

/**
 * Generated class for the GmoPaymentComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'okagepay-payment',
  templateUrl: 'okagepay-payment.html'
})
export class OkagepayPaymentComponent {

    
    @ViewChild('okagepayForm') okagepayForm: any;
    okagepaypayment:any;

    constructor() {
    }

    submit(){
        this.okagepayForm.nativeElement.submit();
    }

}



// WEBPACK FOOTER //
// ./src/components/okagepay-payment/okagepay-payment.ts